import NotFound from "@/components/common/NotFound";
import AppLayout from "@/layout/AppLayout";
import {
  createFileRoute, redirect,
} from "@tanstack/react-router";
import { store } from "@/store";

export const Route = createFileRoute("/(app)")({
  beforeLoad: async () => {
    const user = store.getState().auth.currentUser;
    
    // Check if user is logged in
    if (!user) {
      throw redirect({ to: "/login" });
    }
    
    // No store yet → send to the create-store wizard
    if (!user.name) {
      throw redirect({ to: "/store/create" });
    }
  },
  component: AppLayout,
  notFoundComponent: NotFound,
});

